import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { onsite } from '../../redux/actions/filterActions';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { isMobile } from "react-device-detect";

const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 24,
        height: 24,
        boxShadow: '0px 0px 10px rgba(37, 114, 250, 0.45)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto #2572FA',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#2572FA',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 24,
            height: 24,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#2572FA',
        },
    },
    radioBox:{
        marginLeft: isMobile? 20 : 63,
        color: '#162946',
    },
    radio2:{
        marginLeft: 22
    }

});


function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            label=""
            {...props}
        />
    );
}


const Onsite = ({onsite }) => {

    const [state, setState] = useState('');
    const handleChange = (event) => {
        setState(event.target.value);
        onsite(event.target.value);
        localStorage.setItem('onsite', event.target.value);
    };
    const classes = useStyles();

    useEffect(() => {
        if (localStorage.getItem('onsite')) {
            setState(localStorage.getItem('onsite'));
            onsite(localStorage.getItem('onsite'));
        }
    }, []);

    return (
        <Box className={classes.radioBox}>
            <RadioGroup  onChange={(e, newValue) => handleChange(e)} value={state}>
                <div><StyledRadio value="1" /> В офисе<StyledRadio value="2" className={classes.radio2}/>Удаленно</div>
                <div><StyledRadio value="4" /> В офисе или удаленно</div>
            </RadioGroup>
        </Box>

    );
}

const mapStateToProps = state => ({
    onsite: state.onsite,
})

export default connect(mapStateToProps, { onsite, })(Onsite)